"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _RightRailFlyout = _interopRequireDefault(require("../RightRailFlyout.context"));

var _RightRailFlyoutItem = require("./RightRailFlyoutItem.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RightRailFlyoutItem = function RightRailFlyoutItem(_ref) {
  var backgroundColor = _ref.backgroundColor,
      link = _ref.link,
      text = _ref.text,
      theme = _ref.theme,
      icon = _ref.icon;
  var context = (0, _react.useContext)(_RightRailFlyout["default"]);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  if (!context) {
    throw new Error('<RightRailFlyoutItem /> must be a child of <RightRailFlyout />');
  }

  var _theme$rightRailFlyou = theme.rightRailFlyout;
  _theme$rightRailFlyou = _theme$rightRailFlyou === void 0 ? {} : _theme$rightRailFlyou;
  var _theme$rightRailFlyou2 = _theme$rightRailFlyou.squareWidth,
      squareWidth = _theme$rightRailFlyou2 === void 0 ? 55 : _theme$rightRailFlyou2;
  var rightRailFlyoutItemRef = (0, _react.useCallback)(function (el) {
    if (el !== null) {
      setWidth(el.getBoundingClientRect().width);
    }
  }, []);

  var onMouseOver = function onMouseOver() {
    return setHover(true);
  };

  var onMouseOut = function onMouseOut() {
    return setHover(false);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_RightRailFlyoutItem.StyledRightRailFlyoutItem, {
    backgroundColor: backgroundColor,
    containerWidth: width,
    hover: hover,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    ref: rightRailFlyoutItemRef,
    squareWidth: squareWidth
  }, /*#__PURE__*/_react["default"].createElement(_RightRailFlyoutItem.StyledRightRailFlyoutContainer, null, /*#__PURE__*/_react["default"].createElement(_RightRailFlyoutItem.StyledRightRailFlyoutItemIcon, {
    squareWidth: squareWidth
  }, /*#__PURE__*/_react["default"].createElement(_RightRailFlyoutItem.StyledRatioBox, null, icon)), /*#__PURE__*/_react["default"].createElement(_RightRailFlyoutItem.StyledRightRailFlyoutItemLabel, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: link
  }, text)))));
};

RightRailFlyoutItem.defaultProps = {
  backgroundColor: 'mid-gray'
};
RightRailFlyoutItem.propTypes = {
  /** Background color of the rightRailFlyout item. Should be a framework variable */
  backgroundColor: _propTypes.string,

  /** Icon of the rightRailFlyout Item */
  icon: _propTypes.node.isRequired,

  /** Determines if the rightRailFlyout item should be initially expanded */
  link: _propTypes.string.isRequired,

  /** Title of the rightRailFlyout item */
  text: _propTypes.string.isRequired,

  /** Theme object. Passed automatically by the ThemeProvider high-order component */
  theme: (0, _propTypes.shape)({}).isRequired
};
RightRailFlyoutItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RightRailFlyoutItem",
  "props": {
    "backgroundColor": {
      "defaultValue": {
        "value": "'mid-gray'",
        "computed": false
      },
      "description": "Background color of the rightRailFlyout item. Should be a framework variable",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "description": "Icon of the rightRailFlyout Item",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "link": {
      "description": "Determines if the rightRailFlyout item should be initially expanded",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "text": {
      "description": "Title of the rightRailFlyout item",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(RightRailFlyoutItem);

exports["default"] = _default;